export class PaginationDto {
  paginationFlag: boolean = true;
  start: number = 0;
  end: number = 0;
  pageSize: number = 10;
  currentPage: number = 1;
  recordSum: number = 0;
  pageSum: number = 0;
}
